/**
 * Format Text
 */

export const formatText = (text) => {
  if (text.includes(" ")) {
    let textArr = text.split(" ");
    return `${textArr[0]}-${textArr[1]}`;
  } else {
    return text;
  }
};

/**
 * Format Lang Text
 */

export const formatLangText = (lang) => {
  if (
    lang === "C, C++, C#" ||
    lang === "Objective C" ||
    lang === "Kotlin" ||
    lang === "Java" ||
    lang === "Dart"
  ) {
    return "javascript";
  } else {
    return lang.toLowerCase();
  }
};
